var React = require('react');

function CarrotRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M7.75,7.71446609 L10.25,9.75 L12.75,7.71446609 L15.982233,4.48223305 C16.9585438,3.50592232 18.5414562,3.50592232 19.517767,4.48223305 C20.4940777,5.45854378 20.4940777,7.04145622 19.517767,8.01776695 L12.017767,15.517767 C11.0414562,16.4940777 9.45854378,16.4940777 8.48223305,15.517767 L0.982233047,8.01776695 C0.00592231765,7.04145622 0.00592231765,5.45854378 0.982233047,4.48223305 C1.95854378,3.50592232 3.54145622,3.50592232 4.51776695,4.48223305 L7.75,7.71446609 Z","transform":"rotate(-90 10.25 10)"}));
}

CarrotRightInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = CarrotRightInline;

CarrotRightInline.default = CarrotRightInline;
